/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DataQualityJobStatus {

    Queued = 'queued',

    Running = 'running',

    RetryWait = 'retry_wait',

    CancelRequested = 'cancel_requested',

    Succeeded = 'succeeded',

    Failed = 'failed',

    Cancelled = 'cancelled'
}
